import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export const getDigitalAssets = async () => {
  const data = await axios.get(`${api_base_url}`);
  return data;
};
export const getDigitalAssetsReport = async () => {
  return await axios
    .get(`${api_base_url}/DigitalAssetsReport`)

    .then((res) => {
      return res.data;
    });
};

export const addDigitalAssets = async (newDa) => {
  const formData = new FormData();

  for (const properties in newDa) {
    if (newDa[properties] !== null && newDa[properties] !== undefined) {
      formData.append(`${properties}`, newDa[properties]);
    }
  }
  return await axios.post(`${api_base_url}`, formData);
};

export const editDigitalAssets = async (updatedDa) => {
  const formData = new FormData();
  for (const properties in updatedDa) {
    if (updatedDa[properties] !== null && updatedDa[properties] !== undefined) {
      formData.append(`${properties}`, updatedDa[properties]);
    }
  }
  return await axios.put(`${api_base_url}`, formData);
};

export const getOfficeDetails = async () => {
  return axios
    .get(`${api_base_url}/OfficeDetailsForDigitalAssets`)
    .then((res) => {
      return res.data;
    });
};

export const deleteDigitalAssets = async (ids) => {
  await axios.delete(`${api_base_url}`, {
    data: ids,
  });
};

export const getDigitalAssetsByOfficeCode = async (officeCodes) => {
  let officeCode = officeCodes !== undefined ? officeCodes : 0;
  let officeDigitalAssetsData;
  await axios
    .get(`${api_base_url}/DigitalAssets/${officeCode}`)
    .then((res) => (officeDigitalAssetsData = res.data[0]));
  return officeDigitalAssetsData;
};
export const getOnlineDirectories = async () => {
  const { data } = await axios.get(`${api_base_url}/OnlineDirectories`);
  return data;
};

export const getDigitalAssetsCount = async () => {
  return axios.get(`${api_base_url}/GetDigitalAssetsCount/`).then((res) => {
    return res.data;
  });
};
export const getDigitalService = async () => {
  return await axios.get(`${api_base_url}/DigitalService`).then((res) => {
    return res.data;
  });
};

export const getDigitalAssetsDownload = async (ids) => {
  return await axios
    .post(`${api_base_url}/GetDigitalAssetsDownload`, ids)
    .then((res) => {
      return res.data;
    });
};
